export const P0003600ProgrammeFiltrationAuto = [
  {
    ref: 0,
    label: 'P0003600.filtration.programme.usine1',
    visible: true,
    value: 'PUI1',
  },
  {
    ref: 1,
    label: 'P0003600.filtration.programme.usine2',
    visible: true,
    value: 'PUI2',
  },
  {
    ref: 2,
    label: 'P0003600.filtration.programme.usine3',
    visible: true,
    value: 'PUI3',
  },
  {
    ref: 3,
    label: 'P0003600.filtration.programme.hiver',
    visible: true,
    value: 'PPH',
  },
  {
    ref: 4,
    label: 'P0003600.filtration.programme.ete',
    visible: true,
    value: 'PPE',
  },
  {
    ref: 5,
    label: 'P0003600.filtration.programme.72h',
    visible: false,
    value: '72H',
  },
  {
    ref: 6,
    label: 'P0003600.filtration.programme.loi',
    visible: true,
    value: 'AUTO',
  },
];
export const P0003600ProgrammeFiltrationAutoSans = [
  { ref: 0, label: 'P0003600.filtration.programme.usine1', visible: true },
  { ref: 1, label: 'P0003600.filtration.programme.usine2', visible: true },
  { ref: 2, label: 'P0003600.filtration.programme.usine3', visible: true },
  { ref: 3, label: 'P0003600.filtration.programme.hiver', visible: true },
  { ref: 4, label: 'P0003600.filtration.programme.ete', visible: true },
  { ref: 5, label: 'P0003600.filtration.programme.72h', visible: false },
  { ref: 6, label: 'P0003600.filtration.programme.loi', visible: false },
];
